export enum ContentTransformTypes {
    CONTAIN = 'CONTAIN',
    COVER = 'COVER',
    COVER_WIDTH = 'COVER_WIDTH',
    COVER_HEIGHT = 'COVER_HEIGHT',
    FREE = 'FREE',
    TEXT = 'TEXT',
}
